import { render, staticRenderFns } from "./SiteTable.vue?vue&type=template&id=497aed56&scoped=true&"
import script from "./SiteTable.vue?vue&type=script&lang=js&"
export * from "./SiteTable.vue?vue&type=script&lang=js&"
import style0 from "./SiteTable.vue?vue&type=style&index=0&id=497aed56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497aed56",
  null
  
)

export default component.exports